// When this file is changed, run `yarn ui:genColors` to regenerate ui/styles/_colors.scss.
import type { CSSProperties } from "react";

export const colors = {
  transparent: "transparent",
  white: "#ffffff",
  black: "#222222",
  brandBlack: "#222222",
  brandWhite: "#ffffff",
  brandLightGreen: "#eafaf1",
  brandDarkGray: "#616161",
  brandGreen: "#4dd689",
  brandLightGray: "#f0f0f0",
  brandMediumGray: "#b8b8b8",
  gray05: "#fafafa",
  gray10: "#f5f5f5",
  gray20: "#f0f0f0",
  gray30: "#e5e5e5",
  gray40: "#d6d6d6",
  gray50: "#b8b8b8",
  gray60: "#8a8a8a",
  gray70: "#616161",
  gray80: "#3d3d3d",
  gray90: "#2e2e2e",
  gray95: "#222222",
  alphaDark05: "rgba(0,0,0,0.05)",
  alphaDark10: "rgba(0,0,0,0.1)",
  alphaDark20: "rgba(0,0,0,0.2)",
  alphaDark30: "rgba(0,0,0,0.3)",
  alphaDark40: "rgba(0,0,0,0.4)",
  alphaDark50: "rgba(0,0,0,0.5)",
  alphaDark60: "rgba(0,0,0,0.6)",
  alphaDark70: "rgba(0,0,0,0.7)",
  alphaDark80: "rgba(0,0,0,0.8)",
  alphaDark90: "rgba(0,0,0,0.9)",
  alphaDark95: "rgba(0,0,0,0.95)",
  alphaLight05: "rgba(255,255,255,0.05)",
  alphaLight10: "rgba(255,255,255,0.1)",
  alphaLight20: "rgba(255,255,255,0.2)",
  alphaLight30: "rgba(255,255,255,0.3)",
  alphaLight40: "rgba(255,255,255,0.4)",
  alphaLight50: "rgba(255,255,255,0.5)",
  alphaLight60: "rgba(255,255,255,0.6)",
  alphaLight70: "rgba(255,255,255,0.7)",
  alphaLight80: "rgba(255,255,255,0.8)",
  alphaLight90: "rgba(255,255,255,0.9)",
  alphaLight95: "rgba(255,255,255,0.95)",
  blueDarkest: "#152c4c",
  blueDark: "#234b7f",
  blue: "#336cb8",
  blueLight: "#abc2e2",
  blueLightest: "#d8e3f2",
  yellowDarkest: "#634f21",
  yellowDark: "#a68438",
  yellow: "#f0c051",
  yellowLight: "#f9e5b7",
  yellowLightest: "#fcf3de",
  orangeDarkest: "#65321c",
  orangeDark: "#a95330",
  orange: "#f57945",
  orangeLight: "#fbc8b2",
  orangeLightest: "#fde6dc",
  greenDarkest: "#1d4932",
  greenDark: "#317b53",
  green: "#47b279",
  greenLight: "#b3dfc8",
  greenLightest: "#dcf0e6",
  redDarkest: "#652624",
  redDark: "#a9403d",
  red: "#f55d58",
  redLight: "#fbbcba",
  redLightest: "#fde0df",
  purpleDarkest: "#2f2552",
  purpleDark: "#4e3f89",
  purple: "#715bc7",
  purpleLight: "#c4bbe8",
  purpleLightest: "#e4e0f4",
  magenta: "#ff00ff",
  // Okabe-Ito colorblind-safe palette used by lot-status badges
  greenAccessible: "#009E73",
  blueAccessible: "#0072B2",
  purpleAccessible: "#7B4FA6",
  yellowAccessible: "#F0E442",
  orangeAccessible: "#C05000",
  pinkAccessible: "#CC79A7",
  grayAccessible: "#CCCCCC",
} as const;

export interface ColorSpecificCSSProps extends Omit<CSSProperties, "color" | "backgroundColor" | "borderColor"> {
  color?: ColorLabel;
  backgroundColor?: ColorLabel;
  borderColor?: ColorLabel;
}

export type ColorLabel = keyof typeof colors;
export type ColorValue = (typeof colors)[ColorLabel];

export function getThemeColor(color?: ColorLabel, fallback?: ColorLabel): ColorValue | undefined {
  if (color && colors[color]) {
    return colors[color];
  }

  if (fallback && colors[fallback]) {
    return colors[fallback];
  }

  return undefined;
}

export default colors;
